import {Component, Input} from '@angular/core';
import {PolicyCpi} from '../../../../models/policy.model';
import {NzModalRef} from 'ng-zorro-antd/modal';

@Component({
    selector: 'app-cpi-policy-modal',
    templateUrl: './cpi-policy-modal.component.html',
})
export class CpiPolicyModalComponent {

    @Input() policy: PolicyCpi;

    constructor(private modalRef: NzModalRef) {
    }

    close() {
        this.modalRef.close();
    }

}
